// A shift started without internet: kept on this device and sent to the server
// before the offline orders, so those orders join it.

const keyOf = () => `offline_shift_start:${localStorage.getItem("shopId")}`;

// { counter, openingCash, openingNote, openedAt } or null
export const getPendingShiftStart = () => {
  try {
    return JSON.parse(localStorage.getItem(keyOf()) || "null");
  } catch (error) {
    return null;
  }
};

export const savePendingShiftStart = (start) =>
  localStorage.setItem(keyOf(), JSON.stringify(start));

export const clearPendingShiftStart = () => localStorage.removeItem(keyOf());

export const isLocalShift = (shift) => !!shift?.local;

// how the shift looks on this device until the server has it
export const localShiftOf = (start, userId) => ({
  id: `local-${start.openedAt}`,
  local: true,
  status: "open",
  counter: start.counter,
  opening_cash: start.openingCash,
  opening_note: start.openingNote,
  opened_by: userId,
  opened_at: start.openedAt,
});
